import { BaseModel } from "./base/base.model";

export class AppUsersDocs extends BaseModel {
    docUser1?: string;
    doc?: string;
    user?: string;
    userData?: any;
    docData?: any;
    createdAt?: Date;
    modifiedOn?: Date;
}